import Constant from "@constant/index.js";
import Intercept from "@observer/Intercept.js";

export default class BookingWapView{
    constructor(model){
        this._model = model;
        this._model._view = this;
        this._parentEl = this._model._parent._view._headerBoxEl;
        this._el = null;
    }

    render(){
        let html = "";
        if(this._model._parent._parent._itemType != Constant.GROUP_TYPE.PACKAGE.TYPE){ 
            html += `<div class="clearfix good_item_head" tag='booking'>
                    <span class="item le_tag">${this._model._name}</span>
                    <span class="item name"><span tag='bookingdesc'>${this._model._desc}</span>&nbsp;<span class="le_color_red" tag='bookingleft'>${this._model._leftTime}</span></span>
                </div>`

            // if(this._model._parent._parent._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE){
            //     $(this._parentEl).append($(html));
            // }else{
            //     $(this._parentEl).prepend($(html));
            // }
            $(this._parentEl).append($(html));
            this._el = $(this._parentEl).find("[tag='booking']");
            this.interceptList();
        }
    }

    interceptList(){
        let time = $(this._el).find("[tag=bookingleft]");
        new Intercept().init(time, this._model, "_leftTime");

        let desc = $(this._el).find("[tag=bookingdesc]");
        new Intercept().init(desc, this._model, "_desc");
    }
}